import React from 'react';
import { IconProps } from 'common/interfaces';
import useDefaultIconsColor from 'hooks/use-default-icons-color';

export const ListViewIcon = ({ width = 12, height = 12, color: colorProp, fill: fillProp, hovered }: IconProps) => {
  const { defaultColor } = useDefaultIconsColor();
  const color = colorProp || defaultColor;

  return (
    <svg width={width} height={height} viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M2.57666 4.196H10.5767'
        stroke={color}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2.57666 11.4126H10.5767'
        stroke={color}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M0.689941 4.696C0.966084 4.696 1.18994 4.47214 1.18994 4.196C1.18994 3.91986 0.966084 3.696 0.689941 3.696C0.413799 3.696 0.189941 3.91986 0.189941 4.196C0.189941 4.47214 0.413799 4.696 0.689941 4.696Z'
        fill={color}
      />
      <path
        d='M2.57617 0.587357H10.5762'
        stroke={color}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M0.689453 1.08736C0.965595 1.08736 1.18945 0.863499 1.18945 0.587357C1.18945 0.311214 0.965595 0.0873566 0.689453 0.0873566C0.413311 0.0873566 0.189453 0.311214 0.189453 0.587357C0.189453 0.863499 0.413311 1.08736 0.689453 1.08736Z'
        fill={color}
      />
      <path
        d='M0.689941 11.9126C0.966084 11.9126 1.18994 11.6888 1.18994 11.4126C1.18994 11.1365 0.966084 10.9126 0.689941 10.9126C0.413799 10.9126 0.189941 11.1365 0.189941 11.4126C0.189941 11.6888 0.413799 11.9126 0.689941 11.9126Z'
        fill={color}
      />
      <path
        d='M2.57666 7.80437H10.5767'
        stroke={color}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M0.689941 8.30437C0.966084 8.30437 1.18994 8.08051 1.18994 7.80437C1.18994 7.52822 0.966084 7.30437 0.689941 7.30437C0.413799 7.30437 0.189941 7.52822 0.189941 7.80437C0.189941 8.08051 0.413799 8.30437 0.689941 8.30437Z'
        fill={color}
      />
    </svg>
  );
};
